<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-file-invoice-dollar"></i>
        그룹 청구서 정보
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">청구</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">청구서 그룹</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card id="_share">
          <div class="d-flex flex-wrap align-items-center" v-if="is_show">
            <div class="title mr-auto mb7">
              청구서 안내
            </div>
            <div class="mb7">
              <b-button size="sm" class="float-right" variant="add" @click="share"> 다운로드 </b-button>
            </div>
          </div>
          <hr>
          <div>
            <div id="header" style="height: 150px;margin: 5px;" v-if="is_show">
              <img v-if="model.partner && model.partner.logo" :src="model.partner.logo" alt="partner logo" width="200">
              <!-- <br> -->
              #(08513) 서울특별시 금천구 벚꽃로 234, 에이스하이엔드타워 6차 1402호
              <br>
              gpartners@f1security.co.kr
              <span class="float-right">{{ model.description }}</span>
            </div>
            <div id="body">
              <center style="border-bottom: blue solid 2px; margin: 10px auto; width: 550px; padding-bottom: 20px;">
                <p style="font-weight: bold; margin: 0; font-size: 24px;">
                  UWSS(<span style="font-weight:500;">통합 웹보안 서비스</span>) 청구서
                </p>
                <span>UWSS 계정 및 청구서에 대한 이메일을 보내거나 파트너에게 문의하세요.</span>
              </center>
  
              <div style="min-height: 300px; margin-top:50px;">
                <div style="text-align: left; width: 40%; margin-left: 30px; float: left;">
                  <h2 style="border-bottom: skyblue solid 1px;">사용자 미리보기</h2>
                  <div style="border-bottom: blue solid 2px;">
                    <p style="padding-left: 20px; border-bottom: skyblue solid 1px; padding-bottom: 15px;">
                      계좌 : <span style="float: right;">{{ model.group.groupname }}</span>
                    </p>
                    <!-- Todo : 번역 수정해야함 -->
                    <p style="padding-left: 20px">
                      그룹으로 청구(고객) : <span style="float: right;">{{ model.group.groupname }}</span>
                    </p>
                    <p style="padding-left: 20px;">
                      주소로 청구 : <span style="float: right;">{{ model.group.address }}</span>
                    </p>
                  </div>
                </div>
  
                <div style="text-align: left; width: 45%; margin-right: 60px; float: right;">
                  <h2 style="border-bottom: skyblue solid 1px;">청구서 미리보기</h2>
                  <div style="border-bottom: blue solid 2px;">
                    <p style="padding-left: 20px; border-bottom: skyblue solid 1px; padding-bottom: 10px;">
                      번호: <span style="float: right;"> {{ model.invoice_id }} </span>
                      <br>
                      날짜: <span style="float: right;"> {{ model.created_at | sdate }} </span>
                    </p>
                    <p style="padding-left: 20px;">
                      전체 비용: <span style="float: right;"> {{ model.currency }}  {{ (model.total_price + model.total_paid) | dollar }} </span>
                    </p>
                  </div>
                </div>
              </div>
  
              <div style="margin: 0 auto; text-align: left; padding-left: 29px;">
                <div>
                  <h2 style="padding-bottom: 0px; width: 80%;">
                    청구 기간: {{ model.start_at | date }}  - {{ model.end_at | date }}
                  </h2>
                  <p style="padding-left: 15px;">
                    <!-- F1Security 에서 인사드립니다. -->
                    F1Security 에서 인사드려요.
                    <br>
                    저희는 UWSS 사용자를 위해 전자 청구서를 만들었어요.
                    
                    <!-- Todo : console site 에 청구 페이지가 있는지 확인해야해야함 -->
                    <br>
                    자세한 정보는 콘솔 사이트에서 청구 페이지에서 확인 가능해요.
                    <br>
                    원한다면 PDF 파일을 다운받을 수 있어요.
                  </p>
                </div>
                <br>
                <table style="width: 100%; text-align: left; border-collapse: collapse; border-spacing: 0; margin: 0 auto;">
                  <tr style="background-color: gainsboro;">
                    <th style="padding: 5px;" colspan="3">세부 정보</th>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">UWSS 서비스 유형</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.service.service_name  }} </td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">수량과 사용량</td>
                    <td style="border-top: black solid 1px;">{{ model.service_unit }}</td>
                    <td style="border-top: black solid 1px;">{{ model.base_price }}</td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WEBCastle (웹 방화벽)</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.wc_usage }} </td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WSFinder (웹쉘 탐지 시스템)</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.wsf_usage }} </td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WMDS (웹 악성코드 유포지 탐색 시스템)</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.wmds_usage }} </td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WFDetector (웹 위변조 탐지 시스템)</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.wf_usage }} </td>
                  </tr>
                  <tr>
                    <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">할인</td>
                    <td style="border-top: black solid 1px;">{{ model.discount_price }} </td>
                  </tr>
                  <tr style="background-color: skyblue;">
                    <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">
                      <span class="text-danger">*</span>
                      비용 (부가 가치세 포함)
                    </td>
                    <td style="border-top: black solid 1px;"> {{ model.total_price }} </td>
                  </tr>
                </table>
              </div>
            </div>
            <div id="footer" style="height:60px;">
              <img style="float:right;" v-if="model.partner && model.partner.logo" :src="model.partner.logo" alt="partner logo" width="200">
            </div>
          </div>
        </b-card>
        <b-card id="_share">
          <!-- 부분 결제가 있을 경우 히스토리 내역 필요 -->
          <b-row>
            <b-col md="12">
              <label class="col-form-label" for=""><h4>부분 결제내역</h4></label>
            </b-col>
            <b-col md="12">
              <!-- TODO : 테이블로 예쁘게 해야 함 -->
              <ul class="list-group">
                <li class="list-group-item" v-for="(item, index) in payment_history" v-bind:key="index" v-bind:class="{ strong: item.hp > 300 }">
                  <small v-if="item && item.payer">
                    <!-- paypal -->
                    <!-- {{item}} -->
                    [결제 날짜:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
                    [회사:{{item.payer.email_address}}]
                    [작업:{{item.purchase_units[0].description}}]
                    [결제 방식:{{item.pg}}]
                    [비용:{{item.purchase_units[0].amount.value}}]
                    [현재 단위:{{item.purchase_units[0].amount.currency_code}}]
                    [국가:{{item.payer.address.country_code}}]
                  </small>
                  <small v-else>
                    <!-- boot_pay or credit -->
                    [결제 날짜:{{item.purchased_at | datetime}}]
                    [회사:{{item.pg_name}}]
                    [작업:{{item.action}}]
                    [결제 방식:{{item.pg}}]
                    [비용:{{item.price}}]
                    [현재 단위:{{'KRW'}}]
                    [국가:{{'KR'}}]
                  </small>
                </li>
              </ul>
            </b-col>
          </b-row>
          <hr v-if="is_show">
          <b-button v-if="is_show" :disabled="model.is_paid" class="float-left m-1" size="sm" variant="outline-primary" @click="is_pay = true; model.pay_price = model.total_price"> 수동 결제 </b-button>
          <b-button v-if="is_show" size="sm" class="float-right m-1" variant="primary" @click="list"> 목록 </b-button>
        </b-card>
      </b-col>
    </b-row>
  
    <router-view></router-view>
    <!-- modal area -->
    <b-modal title="수동 결제" header-bg-variant="warning" v-model="is_pay" @ok="pay" ok-variant="outline-warning" ok-title="결제" cancel-title="취소" cancel-variant="outline-dark">
      <!-- <b-checkbox class="ml-3 mt-1" v-model="use_system_credit">Use System Credit (default using partner's credit)</b-checkbox>
      <hr> -->
      <!-- <span> -->
        <!-- Payment can be made with partner's credit or system's credit -->
        <!-- 파트너 신용으로 결제
      </span> -->
      <b-form-input md=12 type="text" id="ph_name" v-model="model.pay_price" ></b-form-input>
    </b-modal>
  </div>
  </template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>